export { BootstrapModalSize, BSModalContext, BSModalContextBuilder } from './modal-context';
export { BSModalContainer } from './modal-container.component';
export {
  BSMessageModal,
  BSMessageModalTitle,
  BSMessageModalBody,
  BSModalFooter,
  BSMessageModalButtonConfig,
  BSMessageModalButtonHandler
} from './message-modal.component';

export {
  MessageModalPreset,
  MessageModalPresetBuilder
} from './presets/message-modal-preset';

export { ModalOpenContext, ModalOpenContextBuilder } from 'angular2-modal';
export { OneButtonPreset, OneButtonPresetBuilder } from './presets/one-button-preset';
export {
  TwoButtonPreset,
  TwoButtonPresetBuilder,
  PromptPreset,
  PromptPresetBuilder
} from './presets/two-button-preset';
export { Modal, bootstrap4Mode } from './modal';

export { BootstrapModalModule, providers } from './bootstrap.module';
